import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c6ca2a4c"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "作废原发票", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "审核后开具", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "redFlush__block-title" }, "原发票信息", -1))
const _hoisted_4 = { class: "redFlush__origin" }
const _hoisted_5 = { class: "redFlush__origin-item" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "发票抬头", -1))
const _hoisted_7 = { class: "value" }
const _hoisted_8 = { class: "redFlush__origin-item" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "发票类型", -1))
const _hoisted_10 = { class: "value" }
const _hoisted_11 = { class: "redFlush__origin-item" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "发票号", -1))
const _hoisted_13 = { class: "value" }
const _hoisted_14 = { class: "redFlush__origin-item" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "发票金额", -1))
const _hoisted_16 = { class: "value" }
const _hoisted_17 = { class: "redFlush__origin-item" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "发票来源", -1))
const _hoisted_19 = { class: "value" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "redFlush__block-title" }, "红冲信息", -1))
const _hoisted_21 = {
  key: 1,
  class: "redFlush__confirm"
}
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "redFlush__confirm-tip" }, "请确认红冲信息，提交后不可撤销。", -1))
const _hoisted_23 = { class: "redFlush__confirm-item" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "发票抬头：", -1))
const _hoisted_25 = { class: "value" }
const _hoisted_26 = { class: "redFlush__confirm-item" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "发票类型：", -1))
const _hoisted_28 = { class: "value" }
const _hoisted_29 = { class: "redFlush__confirm-item" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "发票号：", -1))
const _hoisted_31 = { class: "value" }
const _hoisted_32 = { class: "redFlush__confirm-item" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "发票金额：", -1))
const _hoisted_34 = { class: "value" }
const _hoisted_35 = { class: "redFlush__confirm-item" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "发票来源：", -1))
const _hoisted_37 = { class: "value" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "redFlush__confirm-item" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "label" }, "红冲方式："),
  /*#__PURE__*/_createElementVNode("span", { class: "value" }, "全额红冲（整张发票冲销）")
], -1))
const _hoisted_39 = { class: "redFlush__confirm-item" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "红冲备注：", -1))
const _hoisted_41 = { class: "value" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_alert = _resolveComponent("a-alert")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_textarea = _resolveComponent("a-textarea")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createBlock(_component_a_modal, {
    visible: _ctx.visible,
    "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.visible) = $event)),
    title: _ctx.title,
    width: "640px",
    "mask-closable": false,
    onCancel: _ctx.closeModal
  }, {
    footer: _withCtx(() => [
      (_ctx.step === 'pre')
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createVNode(_component_a_button, { onClick: _ctx.closeModal }, {
              default: _withCtx(() => [
                _createTextVNode("取消")
              ]),
              _: 1
            }, 8, ["onClick"]),
            _createVNode(_component_a_button, {
              type: "primary",
              disabled: !_ctx.canGoNext,
              onClick: _ctx.toNext
            }, {
              default: _withCtx(() => [
                _createTextVNode("下一步")
              ]),
              _: 1
            }, 8, ["disabled", "onClick"])
          ], 64))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createVNode(_component_a_button, { onClick: _ctx.toPre }, {
              default: _withCtx(() => [
                _createTextVNode("上一步")
              ]),
              _: 1
            }, 8, ["onClick"]),
            _createVNode(_component_a_button, {
              type: "primary",
              loading: _ctx.submitting,
              onClick: _ctx.onSubmit
            }, {
              default: _withCtx(() => [
                _createTextVNode("确认提交")
              ]),
              _: 1
            }, 8, ["loading", "onClick"])
          ], 64))
    ]),
    default: _withCtx(() => [
      (_ctx.step === 'pre')
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createVNode(_component_a_alert, {
              type: "warning",
              "show-icon": "",
              class: "redFlush__tip"
            }, {
              message: _withCtx(() => [
                _createTextVNode(" 红冲将"),
                _hoisted_1,
                _createTextVNode("；红字发票将在"),
                _hoisted_2,
                _createTextVNode("。红冲完成后，关联订单将恢复为“可开票”状态。 ")
              ]),
              _: 1
            }),
            _hoisted_3,
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _hoisted_6,
                _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.record.invoiceTitle || '--'), 1)
              ]),
              _createElementVNode("div", _hoisted_8, [
                _hoisted_9,
                _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.invoiceTypeMap[_ctx.record.invoiceType] || '--'), 1)
              ]),
              _createElementVNode("div", _hoisted_11, [
                _hoisted_12,
                _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.record.oilInvoiceNo || _ctx.record.invoiceNo || '--'), 1)
              ]),
              _createElementVNode("div", _hoisted_14, [
                _hoisted_15,
                _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.record.totalFee !== null && _ctx.record.totalFee !== undefined && _ctx.record.totalFee !== '' ? `¥${_ctx.formatWithIntl(_ctx.record.totalFee)}` : '--'), 1)
              ]),
              _createElementVNode("div", _hoisted_17, [
                _hoisted_18,
                _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.record.invoiceApplyTypeDesc || '--'), 1)
              ])
            ]),
            _hoisted_20,
            _createVNode(_component_a_form, { "label-col": { style: 'width: 90px' } }, {
              default: _withCtx(() => [
                _createVNode(_component_a_form_item, { label: "红冲方式" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_input, {
                      value: "全额红冲（整张发票冲销）",
                      disabled: ""
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_form_item, {
                  label: "红冲备注",
                  required: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_textarea, {
                      value: _ctx.remark,
                      "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.remark) = $event)),
                      placeholder: "请填写红冲原因/备注说明（必填）",
                      "show-count": "",
                      maxlength: 200,
                      rows: 4
                    }, null, 8, ["value"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ], 64))
        : (_openBlock(), _createElementBlock("div", _hoisted_21, [
            _hoisted_22,
            _createElementVNode("div", _hoisted_23, [
              _hoisted_24,
              _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.record.invoiceTitle || '--'), 1)
            ]),
            _createElementVNode("div", _hoisted_26, [
              _hoisted_27,
              _createElementVNode("span", _hoisted_28, _toDisplayString(_ctx.invoiceTypeMap[_ctx.record.invoiceType] || '--'), 1)
            ]),
            _createElementVNode("div", _hoisted_29, [
              _hoisted_30,
              _createElementVNode("span", _hoisted_31, _toDisplayString(_ctx.record.oilInvoiceNo || _ctx.record.invoiceNo || '--'), 1)
            ]),
            _createElementVNode("div", _hoisted_32, [
              _hoisted_33,
              _createElementVNode("span", _hoisted_34, _toDisplayString(_ctx.record.totalFee !== null && _ctx.record.totalFee !== undefined && _ctx.record.totalFee !== '' ? `¥${_ctx.formatWithIntl(_ctx.record.totalFee)}` : '--'), 1)
            ]),
            _createElementVNode("div", _hoisted_35, [
              _hoisted_36,
              _createElementVNode("span", _hoisted_37, _toDisplayString(_ctx.record.invoiceApplyTypeDesc || '--'), 1)
            ]),
            _hoisted_38,
            _createElementVNode("div", _hoisted_39, [
              _hoisted_40,
              _createElementVNode("span", _hoisted_41, _toDisplayString(_ctx.remark), 1)
            ])
          ]))
    ]),
    _: 1
  }, 8, ["visible", "title", "onCancel"]))
}